import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { ChatRound, Avatar, Switch, User } from '@element-plus/icons-vue';
import { useRoute } from 'vue-router';
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { TgGetters, TgMutations, TgActions } from "@/store/modules/telegram";
import { TgUser } from '@/store/modules/telegram/types';


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "TgMenu",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const route = useRoute();
const store = useStore();
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const tgIdCom = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});


const changeTgIdDialog = ref<boolean>(false)
const selectMenu = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectMenu}`];
});
const idList = computed(() => {
    return store.getters[`telegram/${TgGetters.getIdList}`];
});

const handleClick = (key: string) => {
    if (key !== "3") {
        store.commit(`telegram/${TgMutations.setSelectMenu}`, key);
        store.commit(`telegram/${TgMutations.setSelectedConv}`, null);
    } else {
        changeTgIdDialog.value = true
    }
}

const handleChooseId = async (selectedUser: TgUser) => {
    const projid = projectId.value
    const uid = targetId.value
    changeTgIdDialog.value = false

    store.commit(`telegram/${TgMutations.resetAll}`);
    store.commit(`telegram/${TgMutations.setSelectMenu}`, "3");

    await store.dispatch(`telegram/${TgActions.asyncGetMeId}`, { projid, uid });
    store.commit(`telegram/${TgMutations.setSelectMenu}`, "1");
    store.commit(`telegram/${TgMutations.setMeId}`, selectedUser.Id);
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      "default-active": _unref(selectMenu),
      class: "tgMenuTabArea",
      collapse: true,
      onSelect: handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "tgMenuItem" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ChatRound))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "tgMenuItem" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Avatar))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "tgMenuItem" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Switch))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_dialog, {
      class: "allUserDialog",
      modelValue: changeTgIdDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((changeTgIdDialog).value = $event)),
      title: "切换账号",
      width: "500px"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idList), (item) => {
          return (_openBlock(), _createElementBlock("div", { key: item }, [
            _createVNode(_component_el_link, {
              onClick: ($event: any) => (handleChooseId(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "hover",
                  style: {"width":"400px","height":"90px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      size: 30,
                      style: {"float":"left","width":"10%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(User))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_text, { style: {"float":"right","width":"88%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode("UserId: " + _toDisplayString(item.Id) + " " + _toDisplayString(_unref(tgIdCom) === item.Id ? "(当前帐号)" : ""), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Name: " + _toDisplayString(item.Name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Username: " + _toDisplayString(item.Username), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})